import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation QuiverDeploy(
    $tenantId: ID!
    $zoneId: ID!
    $commands: [RelayCommandInput!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        execute(commands: $commands)
      }
    }
  }
`

export const execute = graphql.createExecutor<
  graphql.schema.QuiverDeployMutation,
  undefined,
  graphql.schema.QuiverDeployMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
